(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-insert-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('insert-builder')) {
    customElements.define('insert-builder', class InsertBuilder extends HTMLElement {
      connectedCallback() {
        this.capacity = Number(this.dataset.capacity || 9)
        this.cells = []
        this.gapIndex = 0
        this.usable = this.querySelector('[data-builder-usable]')
        this.empty = this.querySelector('[data-builder-empty]')
        this.status = this.querySelector('[data-builder-status]')
        this.configurationInput = this.querySelector('[data-builder-configuration-property]')
        this.undoButton = this.querySelector('[data-builder-undo]')
        this.clearButton = this.querySelector('[data-builder-clear]')
        this.choicesOverflow = this.querySelector('[data-builder-choices-overflow]')
        this.choicesToggle = this.querySelector('[data-builder-choices-toggle]')
        this.form = null
        this.addToCartButton = null
        this.addToCartButtonObserver = null
        this.pointerDrag = null
        this.suppressCellClick = false

        this.querySelectorAll('[data-add-cell]').forEach((button) => {
          button.addEventListener('click', () => this.addCell(button))
        })
        this.undoButton.addEventListener('click', () => {
          this.removeCell(this.cells.length - 1)
        })
        this.clearButton.addEventListener('click', () => {
          this.cells = []
          this.gapIndex = 0
          this.render()
        })
        this.choicesToggle?.addEventListener('click', () => this.toggleChoices())
        this.connectProductForm()
        this.render()
      }

      toggleChoices() {
        if (!this.choicesOverflow || !this.choicesToggle) return

        const expanded = this.choicesToggle.getAttribute('aria-expanded') === 'true'
        this.choicesOverflow.hidden = expanded
        this.choicesToggle.setAttribute('aria-expanded', String(!expanded))
        this.choicesToggle.setAttribute(
          'aria-label',
          expanded ? 'Show more insert cell options' : 'Show fewer insert cell options'
        )
      }

      connectProductForm() {
        this.form = document.getElementById(this.dataset.formId)
        if (!this.form) {
          this.formConnectAttempts = (this.formConnectAttempts || 0) + 1
          if (this.formConnectAttempts < 30) requestAnimationFrame(() => this.connectProductForm())
          return
        }

        this.addToCartButton = this.form.querySelector('[name="add"]')
        // Keep the configuration inside the product form for both checkout paths.
        this.form.append(this.configurationInput)
        this.expressCheckout = this.form.querySelector('[data-insert-checkout]')
        if (this.addToCartButton) {
          this.addToCartButtonObserver = new MutationObserver(() => {
            if (this.cells.length === 0) this.syncAddToCartButton()
          })
          this.addToCartButtonObserver.observe(this.addToCartButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class', 'data-insert-builder-empty']
          })
        }
        this.form.addEventListener('submit', (event) => {
          if (this.cells.length === 0) {
            event.preventDefault()
            this.showError('Add at least one cell before adding this insert to the cart.')
          }
        })
        this.form.addEventListener('change', () => requestAnimationFrame(() => this.render()))
        this.render()
      }

      get usedWidth() {
        return this.cells.reduce((total, cell) => total + cell.width, 0)
      }

      addCell(button) {
        const cell = {
          key: button.dataset.addCell,
          width: Number(button.dataset.width),
          label: button.dataset.label
        }
        if (this.usedWidth + cell.width > this.capacity + 0.001) {
          this.showError(`${cell.label} does not fit. ${this.format(this.capacity - this.usedWidth)}″ remains.`)
          return
        }
        const gapWasAtEnd = this.gapIndex === this.cells.length
        this.cells.push(cell)
        if (gapWasAtEnd) this.gapIndex = this.cells.length
        this.render()
      }

      removeCell(index) {
        if (index < 0 || index >= this.cells.length) return

        if (index < this.gapIndex) this.gapIndex -= 1
        this.cells.splice(index, 1)
        this.gapIndex = Math.max(0, Math.min(this.gapIndex, this.cells.length))
        this.render()
      }

      reorderCell(fromIndex, insertionIndex) {
        if (fromIndex < 0 || fromIndex >= this.cells.length) return

        const layout = this.getLayoutItems()
        const sourceLayoutIndex = layout.findIndex((item) => item.type === 'cell' && item.index === fromIndex)
        const cellItem = layout.splice(sourceLayoutIndex, 1)[0]
        const destination = Math.max(0, Math.min(insertionIndex, layout.length))
        layout.splice(destination, 0, cellItem)
        this.applyLayout(layout, cellItem.cell)
      }

      moveCell(fromIndex, direction) {
        const layout = this.getLayoutItems()
        const sourceLayoutIndex = layout.findIndex((item) => item.type === 'cell' && item.index === fromIndex)
        const targetLayoutIndex = sourceLayoutIndex + direction
        if (sourceLayoutIndex === -1 || targetLayoutIndex < 0 || targetLayoutIndex >= layout.length) return

        const cellItem = layout[sourceLayoutIndex]
        layout[sourceLayoutIndex] = layout[targetLayoutIndex]
        layout[targetLayoutIndex] = cellItem
        this.applyLayout(layout, cellItem.cell)
      }

      handleCellKeydown(event, index) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault()
          this.moveCell(index, -1)
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault()
          this.moveCell(index, 1)
        }
      }

      getLayoutItems() {
        const items = this.cells.map((cell, index) => ({ type: 'cell', cell, index }))
        const remaining = Math.max(0, this.capacity - this.usedWidth)
        if (remaining > 0.001 && this.cells.length > 0) {
          const gapIndex = Math.max(0, Math.min(this.gapIndex, items.length))
          items.splice(gapIndex, 0, { type: 'gap', width: remaining })
        }
        return items
      }

      applyLayout(layout, focusedCell) {
        this.cells = layout.filter((item) => item.type === 'cell').map((item) => item.cell)
        const gapLayoutIndex = layout.findIndex((item) => item.type === 'gap')
        this.gapIndex = gapLayoutIndex === -1
          ? this.cells.length
          : layout.slice(0, gapLayoutIndex).filter((item) => item.type === 'cell').length
        const focusedIndex = this.cells.indexOf(focusedCell)
        this.render()
        requestAnimationFrame(() => {
          this.querySelector(`[data-builder-index="${focusedIndex}"]`)?.focus()
        })
      }

      handlePointerDown(event, index, element) {
        if (event.button !== 0) return

        this.pointerDrag = {
          index,
          startX: event.clientX,
          pointerId: event.pointerId,
          active: false,
          element
        }
        this.classList.add('is-reordering')
        element.setPointerCapture(event.pointerId)
      }

      handlePointerMove(event) {
        if (!this.pointerDrag || event.pointerId !== this.pointerDrag.pointerId) return

        const offset = event.clientX - this.pointerDrag.startX
        if (Math.abs(offset) > 6) {
          this.pointerDrag.active = true
          this.pointerDrag.element.classList.add('is-dragging')
          this.pointerDrag.element.style.setProperty('--drag-offset', `${offset}px`)
          event.preventDefault()
        }
      }

      handlePointerUp(event) {
        if (!this.pointerDrag) return

        const pointerDrag = this.pointerDrag
        this.pointerDrag = null
        this.classList.remove('is-reordering')
        pointerDrag.element.classList.remove('is-dragging')
        pointerDrag.element.style.removeProperty('--drag-offset')
        if (!pointerDrag.active) return

        event.preventDefault()
        this.suppressCellClick = true
        const insertionIndex = this.getInsertionIndex(event.clientX, pointerDrag.index)
        this.reorderCell(pointerDrag.index, insertionIndex)
        setTimeout(() => {
          this.suppressCellClick = false
        })
      }

      cancelPointerDrag() {
        if (this.pointerDrag) {
          this.pointerDrag.element.classList.remove('is-dragging')
          this.pointerDrag.element.style.removeProperty('--drag-offset')
        }
        this.classList.remove('is-reordering')
        this.pointerDrag = null
      }

      getInsertionIndex(clientX, draggedIndex) {
        const items = Array.from(this.usable.querySelectorAll('[data-builder-layout-item]'))
          .filter((item) => item.dataset.builderIndex === undefined || Number(item.dataset.builderIndex) !== draggedIndex)
        return items.reduce((position, item) => {
          const bounds = item.getBoundingClientRect()
          return clientX > bounds.left + bounds.width / 2 ? position + 1 : position
        }, 0)
      }

      render() {
        this.usable.querySelectorAll('[data-builder-layout-item]').forEach((item) => item.remove())
        const remaining = Math.max(0, this.capacity - this.usedWidth)
        const layoutItems = this.getLayoutItems()
        layoutItems.forEach((item) => {
          if (item.type === 'gap') {
            const gap = document.createElement('div')
            gap.className = 'insert-builder__gap'
            gap.dataset.builderGap = ''
            gap.dataset.builderLayoutItem = ''
            gap.style.setProperty('--gap-width', `${(item.width / this.capacity) * 100}%`)
            gap.setAttribute('aria-label', `${this.format(item.width)} inches of available space. Drag a cell here to move the gap.`)
            gap.innerHTML = `<span>${this.format(item.width)}″ available</span>`
            this.usable.appendChild(gap)
            return
          }

          const cell = item.cell
          const index = item.index
          const element = document.createElement('button')
          element.type = 'button'
          element.className = `insert-builder__cell insert-builder__cell--${cell.key}`
          element.dataset.builderCell = ''
          element.dataset.builderLayoutItem = ''
          element.dataset.builderIndex = String(index)
          element.style.setProperty('--cell-width', `${(cell.width / this.capacity) * 100}%`)
          element.setAttribute('aria-label', `${cell.label}, ${this.format(cell.width)} inches. Drag or use the arrow keys to reorder. Press to remove.`)
          element.innerHTML = `<strong>${cell.label}</strong><span>${this.format(cell.width)}″</span>`
          element.addEventListener('click', () => {
            if (this.suppressCellClick) return
            this.removeCell(index)
          })
          element.addEventListener('keydown', (event) => this.handleCellKeydown(event, index))
          element.addEventListener('pointerdown', (event) => this.handlePointerDown(event, index, element))
          element.addEventListener('pointermove', (event) => this.handlePointerMove(event))
          element.addEventListener('pointerup', (event) => this.handlePointerUp(event))
          element.addEventListener('pointercancel', () => this.cancelPointerDrag())
          this.usable.appendChild(element)
        })

        this.empty.hidden = this.cells.length > 0
        this.status.classList.remove('is-error')
        this.status.textContent = `${this.format(this.usedWidth)}″ used · ${this.format(remaining)}″ available`
        this.undoButton.disabled = this.cells.length === 0
        this.clearButton.disabled = this.cells.length === 0

        this.querySelectorAll('[data-add-cell]').forEach((button) => {
          button.disabled = Number(button.dataset.width) > remaining + 0.001
        })

        const configurationInput = this.configurationInput
        const configurationParts = layoutItems.map((item) => {
          if (item.type === 'gap') return `Empty space (${this.format(item.width)} in)`
          return `${item.cell.label} ${this.format(item.cell.width)}\"`
        })
        configurationInput.value = configurationParts.length
          ? `Left to right: ${configurationParts.join(' | ')}`
          : ''
        configurationInput.disabled = configurationParts.length === 0
        this.syncAddToCartButton()
      }

      syncAddToCartButton() {
        if (this.expressCheckout) {
          const empty = this.cells.length === 0
          this.expressCheckout.inert = empty
          this.expressCheckout.setAttribute('aria-disabled', String(empty))
        }
        if (!this.addToCartButton) return

        const requiresConfiguration = this.cells.length === 0
        if (requiresConfiguration) {
          if (this.addToCartButton.dataset.insertBuilderEmpty !== 'true') {
            this.addToCartButton.dataset.insertBuilderEmpty = 'true'
          }
          if (!this.addToCartButton.disabled) this.addToCartButton.disabled = true
          if (!this.addToCartButton.classList.contains('disabled')) this.addToCartButton.classList.add('disabled')
          if (this.addToCartButton.getAttribute('aria-disabled') !== 'true') {
            this.addToCartButton.setAttribute('aria-disabled', 'true')
          }
          return
        }

        const wasBuilderDisabled = this.addToCartButton.dataset.insertBuilderEmpty === 'true'
        delete this.addToCartButton.dataset.insertBuilderEmpty
        if (!wasBuilderDisabled) return

        const currentText = this.addToCartButton.querySelector('.m-add-to-cart--text')?.textContent.trim()
        const availableText = this.addToCartButton.dataset.atcText
        if (!availableText || currentText === availableText) {
          this.addToCartButton.disabled = false
          this.addToCartButton.classList.remove('disabled')
          this.addToCartButton.setAttribute('aria-disabled', 'false')
        }
      }

      showError(message) {
        this.status.textContent = message
        this.status.classList.add('is-error')
      }

      format(value) {
        return Number(value.toFixed(2)).toString()
      }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
